/* eslint @typescript-eslint/naming-convention: 0 */
import dayjs from 'dayjs';

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface SearchExperienceByDateParams {
  // 最短の検索対象日から、検索発火時が何日離れているか
  // 直前予約なのか、かなり先の予定なのかなどを見るため
  date_diff: number;
}

/**
 *
 * @param closestTargetDate YYYY-MM-DDフォーマット
 * @returns
 */
const buildSearchExperienceByDateParams = (closestTargetDate: string): SearchExperienceByDateParams => {
  // diffは二つの日付の間に何日あるかを返す(2024-08-27 2024-08-28の場合、0を返す)ため、何日先かを見るためにはdiffの結果に+1をする
  return { date_diff: dayjs(closestTargetDate).diff(dayjs(), 'day') + 1 };
};

/**
 * 発火タイミング：検索発火時
 * @param targetDates YYYY-MM-DDフォーマットの日付のカンマ区切り文字列
 */
export const sendGAWabunkaSearchExperienceByDateEvent = (targetDates: string) => {
  if (targetDates === '') {
    return;
  }
  // 最短の検索対象日を取得
  const closestTargetDate = targetDates.split(',').sort((a, b) => dayjs(a).diff(dayjs(b)))[0];
  sendWabunkaGAEvent('search_experience_by_date', buildSearchExperienceByDateParams(closestTargetDate));
};
